"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants.js");

var _common = require("./common.js");

var _frameComponent = _interopRequireDefault(require("./frame-component.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SnapchatHeader =
/*#__PURE__*/
function (_FrameComponent) {
  _inherits(SnapchatHeader, _FrameComponent);

  function SnapchatHeader() {
    _classCallCheck(this, SnapchatHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(SnapchatHeader).apply(this, arguments));
  }

  _createClass(SnapchatHeader, [{
    key: "render",
    value: function render() {
      // Defining CSS is not encouraged in React component, but pseudo-selectors and media queries
      // are good platform-agnostic way of expressing header behavior in this case.
      // TODO: evaluate if it makes sense to move CSS to extra file to be consumed by clients explicitly
      var css = "\n      .header-container {\n        position: fixed;\n        width: 100%;\n        font-size: 14px;\n        background-color: #FFFC00;\n        height: 46px;\n        line-height: 46px;\n        z-index: 1000;\n      }\n\n      .globalnav-container {\n        width: 92.3%;\n        max-width: 1070px;\n        margin: auto;\n        white-space: nowrap;\n      }\n\n      .globalnav-container .globalnav-item {\n        margin-right: 24px;\n        display: inline;\n        padding: 2px;\n      }\n\n      .globalnav-container .globalnav-item:hover {\n        border-bottom: 2px solid rgba(38, 38, 38, 0.5);\n      }\n\n      .sc-header-selected-home .globalnav-home-link,\n      .sc-header-selected-create .globalnav-create-link,\n      .sc-header-selected-live .globalnav-live-link,\n      .sc-header-selected-snapcodes .globalnav-snapcodes-link,\n      .sc-header-selected-ads .globalnav-ads-link,\n      .sc-header-selected-download .globalnav-download-link {\n        border-bottom: 2px solid rgb(38, 38, 38);\n      }\n\n      .globalnav-container .globalnav-link {\n        color: rgb(38, 38, 38);\n        font-weight: 500;\n        text-decoration: none;\n        line-height: 22px;\n        font-size: 14px;\n        letter-spacing: .05px;\n      }\n\n      .globalnav-container .globalnav-ghost-icon-link {\n        position: absolute;\n        top: 9px;\n      }\n\n      .globalnav-container .globalnav-home-link {\n        visibility: hidden;\n      }\n\n      .header-hamburger {\n        display: none;\n      }\n\n      .sc-header-replace-ghost-home-with-text .globalnav-container .globalnav-ghost-icon-link {\n        display: none;\n      }\n      .sc-header-replace-ghost-home-with-text .globalnav-container .globalnav-home-link {\n        visibility: inherit;\n      }\n      .sc-header-white .header-container,\n      .sc-header-white.header-container {\n        background-color: white;\n      }\n\n      @media (min-width: 1070px) {\n        .sc-header-white .header-container,\n        .sc-header-white.header-container {\n          border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        }\n      }\n\n      @media (max-width: 1070px) {\n        .globalnav-container {\n          position: absolute;\n          top: 46px;\n          width: 100%;\n          border-top: 1px solid #D4D4D4;\n          border-radius: 2px;\n          max-height: 0;\n          transition: max-height .25s ease-in-out;\n          overflow: hidden;\n        }\n        .globalnav-container .globalnav-ghost-icon-link {\n          display: none;\n        }\n\n        .hamburger-expanded .globalnav-container {\n          border-bottom: 1px solid #D4D4D4;\n          max-height: 620px;\n        }\n\n        .globalnav-container .globalnav-home-link {\n          visibility: inherit;\n        }\n\n        /* a hover selector to overwrite desktop hover hightlight */\n        .globalnav-container .globalnav-item,\n        .globalnav-container .globalnav-item:hover {\n          display: block;\n          width: 100%;\n          padding: 0;\n          text-align: right;\n          background-color: white;\n          border-bottom: 1px solid #F8F9FB;\n        }\n\n        .globalnav-container .globalnav-item:hover {\n          background-color: #F8F9FB;\n        }\n\n        .globalnav-container .globalnav-item .globalnav-link {\n          display: block;\n          padding-right: 13px;\n          line-height: 46px;\n        }\n\n        .sc-header-selected-home .globalnav-home-link,\n        .sc-header-selected-create .globalnav-create-link,\n        .sc-header-selected-live .globalnav-live-link,\n        .sc-header-selected-snapcodes .globalnav-snapcodes-link,\n        .sc-header-selected-ads .globalnav-ads-link,\n        .sc-header-selected-download .globalnav-download-link {\n          background-color: #F8F9FB;\n        }\n\n        .header-hamburger {\n          display: block;\n          width: 20px;\n          height: 15px;\n          line-height: 15px;\n          position: relative;\n          top: 14px;\n          right: 15px;\n          float: right;\n          margin: 0;\n          transform: rotate(0deg);\n          cursor: pointer;\n        }\n\n        .header-hamburger span {\n          display: block;\n          position: absolute;\n          height: 2.5px;\n          width: 100%;\n          background: rgb(38, 38, 38);\n          box-sizing: border-box;\n          border-radius: 1px;\n          opacity: 1;\n          left: 0;\n          transform: rotate(0deg);\n          transition: .25s ease-in-out;\n          transition-property: transform, opacity;\n        }\n\n        .header-hamburger span:nth-child(1) {\n          top: 0px;\n          transform-origin: left center;\n        }\n\n        .header-hamburger span:nth-child(2) {\n          top: 6px;\n          transform-origin: left center;\n        }\n\n        .header-hamburger span:nth-child(3) {\n          top: 12px;\n          transform-origin: left center;\n        }\n\n        .hamburger-expanded .header-hamburger span:nth-child(1) {\n          transform: rotate(45deg) translateY(-1.5px);\n        }\n\n        .hamburger-expanded .header-hamburger span:nth-child(2) {\n          transform: scaleX(0);\n          opacity: 0;\n        }\n\n        .hamburger-expanded .header-hamburger span:nth-child(3) {\n          transform: rotate(-45deg) translateY(1px);\n        }\n      }\n    ";
      var domain = (0, _common.getDomainForURLs)(this.props.domain);
      var gettext = this.createStringSelector();
      var locSuffix = this.getLocaleUrlSuffixForWWW();
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            height: 46
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("style", null, css),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "header-container"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "header-hamburger",
          id: "headerHamburger",
          ref: _common.registerHamburgerEvents
        },
        /*#__PURE__*/
        _react["default"].createElement("span", null),
        /*#__PURE__*/
        _react["default"].createElement("span", null),
        /*#__PURE__*/
        _react["default"].createElement("span", null)),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-container"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://www.".concat(domain, "/").concat(locSuffix),
          className: "globalnav-ghost-icon-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("img", {
          src: "https://www.".concat(domain, "/static/style-guide/images/ghost/ghost.svg"),
          alt: gettext('Snapchat'),
          style: {
            height: 64
          }
        })),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-home-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://www.".concat(domain, "/").concat(locSuffix)
        }, gettext('Home'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-download-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://www.".concat(domain, "/").concat(locSuffix, "download")
        }, gettext('Download'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-snapcodes-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://story.".concat(domain, "/spotlight")
        }, gettext('Spotlight'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-stories-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://story.".concat(domain)
        }, gettext('Stories'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-map-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://map.".concat(domain)
        }, gettext('Map'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-ads-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://www.".concat(domain, "/").concat(locSuffix, "ads")
        }, gettext('Ads'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-spectacles-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: 'https://www.spectacles.com'
        }, gettext('Spectacles'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-create-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://www.".concat(domain, "/").concat(locSuffix, "create")
        }, gettext('Create'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-lensstudio-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://lensstudio.".concat(domain)
        }, gettext('Lens Studio'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-kit-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://kit.".concat(domain)
        }, gettext('Kit'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-snapcodes-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://snapcodes.".concat(domain)
        }, gettext('Snapcodes'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-snapcodes-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://support.".concat(domain)
        }, gettext('Support'))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "globalnav-item globalnav-store-link"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          className: "globalnav-link",
          href: "https://store.".concat(domain)
        }, gettext('Store'))))))
      );
    }
  }]);

  return SnapchatHeader;
}(_frameComponent["default"]);

exports["default"] = SnapchatHeader;

_defineProperty(SnapchatHeader, "propTypes", {
  domain: _propTypes["default"].string,
  locale: _propTypes["default"].string
});

_defineProperty(SnapchatHeader, "defaultProps", {
  domain: _constants.DEFAULT_DOMAIN,
  locale: null
});